<template>
    <div>
        <div class="text-center">
            <loader v-if="loading" />
            <div v-else>
                <stripe-terminal-reader />
                <submit-button
                    :processing="processing"
                    color="green"
                    @click="!cardDetails ? collectCardDetails() : registerCanvassedCustomer()">
                    {{ buttonCopy }}
                </submit-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import RegistrationService from '@/services/users/RegistrationService';
import { SECTION_PAYMENT } from '@/constants/Registration';
import Loader from '@/components/structure/Loader.vue';
import SubmitButton from '@/components/forms/buttons/SubmitButton';
import StripeTerminalReader from '../cardDetails/StripeTerminalReader';

export default {
    name: 'StripeTerminalForm',
    components: {
        Loader,
        SubmitButton,
        StripeTerminalReader,
    },
    data() {
        return {
            loading: false,
            processing: false,
        };
    },
    computed: {
        ...mapGetters({
            fullName: 'register/getFullName',
            cardDetails: 'canvasser/getCardDetails',
        }),
        buttonCopy() {
            return !this.cardDetails ? this.$t('SAVE_CARD') : this.$t('CARD_DETAILS_FORM_SIGN_ME_UP');
        },
    },
    methods: {
        ...mapActions({
            collectCardDetails: 'canvasser/collectCardDetails',
        }),
        registerCanvassedCustomer() {
            this.processing = true;
            let payload = {
                payment_token: this.cardDetails?.payment_method?.id,
                stripe_card_id: this.cardDetails?.payment_method?.id,
                payment_method: 'card',
                gateway: 'Stripe',
                name_on_card: this.fullName,
            };
            RegistrationService.registerCanvassedCustomer(payload)
                .then(() => {
                    this.processing = false;
                    this.$store.commit('register/setSectionComplete', SECTION_PAYMENT);
                    this.$store.commit('canvasser/resetCardDetails');
                    this.handleSuccessfulRegistrationCanva();
                })
                .catch(error => {
                    setTimeout(() => this.errorHandler.setResponse(error.response?.data), 0);
                    this.handleFail();
                });
        },
        handleSuccessfulRegistrationCanva() {
            this.$store.commit('register/resetState');
            this.$router.push({ name: 'canvasser-register.confirmation' });
        },
    },
};
</script>
